export default "__VITE_ASSET__DOlKnppR__"